/*
  RK: PRODUCTFOTO'S VOORWARMEN OP DE PRODUCTPAGINA.

  HET PROBLEEM, ZOALS GEMETEN IN DE WINKEL.
  Klik je op een andere kleur, dan vervangt het thema de `src` van de foto in
  de eerste schuifplaat - hetzelfde <img>-element blijft staan, alleen het
  plaatje erin wisselt. Tegelijk verspringen dertien klassen op de plaatjes en
  wordt er een <li> verplaatst. De hoogte van de strook verandert NIET (gemeten:
  813px voor en na), dus het is geen springende bladspiegel.

  De schok die je ziet komt hiervandaan: alle foto's behalve de eerste staan op
  loading="lazy". De foto van die andere kleur is op het moment van klikken dus
  nog nooit opgehaald (gemeten: naturalWidth 0, pas na de klik 975). Tussen het
  wisselen van de `src` en het klaar zijn van de nieuwe foto staat het vak een
  paar beeldjes leeg. Op mobiel valt dat het meest op, want daar is die plaat
  schermbreed.

  DE KLEURVAKJES DOEN HETZELFDE, OOK ALS JE EEN MAAT KIEST.
  Shopify bouwt bij ELKE variantklik het hele variantenblok opnieuw op - ook
  bij een maatklik, waar aan de kleuren niets verandert. De kleine
  kleurplaatjes zijn daarna dus VERSE <img>-elementen. Staat hun plaatje niet
  klaar, dan trillen ze even. Vandaar dat die hier net zo goed voorgewarmd
  worden als de grote foto's.

  WAAROM DE OPGEHAALDE PLAATJES WORDEN VASTGEHOUDEN (keep).
  De eerste versie van dit bestand maakte per foto een los Image-object en
  liet dat daarna vallen. De browser mag zo'n plaatje dan opruimen zodra hij
  krap zit - en dan is het voorwarmen na een paar minuten weer weg en begint
  het trillen opnieuw. Precies dat gebeurde. Door de objecten in een lijst te
  bewaren blijft het gedecodeerde plaatje in leven zolang de pagina open is.
  Het gaat om een handvol foto's van dit ene product; dat is verwaarloosbaar
  geheugen tegenover de schok die het wegneemt.

  WAAROM srcset EN sizes WORDEN OVERGENOMEN EN ER GEEN EIGEN URL WORDT GEBOUWD.
  Het thema levert elke foto in een reeks breedtes. Bouwden we hier zelf een
  adres met ?width=..., dan zou de browser straks alsnog een ANDER bestand uit
  die reeks kiezen en was het voorwarmen voor niets. Door srcset en sizes
  letterlijk over te nemen kiest de browser nu hetzelfde bestand als straks.

  DIT PLAATST OF VERPLAATST NIETS. Het raakt de bladspiegel niet aan en het
  wijzigt geen enkel element van het thema; het vraagt alleen plaatjes op.
*/
(() => {
  if (window.__rkMediaWarm) return;
  window.__rkMediaWarm = true;

  var SEL = [
    'media-gallery .product__media-list img',
    '.product__media-list img',
    'variant-selects img',
    '.product-form__input img'
  ].join(', ');

  /* De plaatjes die we al opgehaald hebben, op adres. De lijst is wat ze in
     leven houdt - zie kop-comment. */
  var keep = Object.create(null);
  var busy = false;

  function warm() {
    if (busy) return;
    busy = true;

    try {
      var imgs = document.querySelectorAll(SEL);
      Array.prototype.forEach.call(imgs, function (img) {
        var src = img.currentSrc || img.getAttribute('src') || '';
        var set = img.getAttribute('srcset') || '';
        if (!src && !set) return;

        /* Op adres, niet op element: na een variantklik zijn de elementen
           vers maar de adressen dezelfde. */
        var key = src + '|' + set;
        if (keep[key]) return;

        var pre = new Image();
        pre.decoding = 'async';
        /* Laag in de rij: de zichtbare pagina gaat voor. */
        if ('fetchPriority' in pre) pre.fetchPriority = 'low';
        if (img.sizes) pre.sizes = img.sizes;
        if (set) pre.srcset = set;
        if (src) pre.src = src;

        keep[key] = pre;

        if (pre.decode) {
          pre.decode().catch(function () {});
        }
      });
    } finally {
      busy = false;
    }
  }

  /* Na een variantklik bouwt het thema het blok opnieuw op; dan nog een keer,
     maar hoogstens een keer per beeldje. */
  var queued = false;
  function later() {
    if (queued) return;
    queued = true;
    var run = function () { queued = false; warm(); };
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    else window.setTimeout(run, 16);
  }

  function start() {
    if (!document.querySelector(SEL)) return;

    if (window.requestIdleCallback) {
      window.requestIdleCallback(warm, { timeout: 2500 });
    } else {
      window.setTimeout(warm, 700);
    }

    /* Raakt iemand een kleur of maat aan, dan is wachten op een rustig moment
       te laat - dan meteen. */
    ['pointerenter', 'pointerdown', 'touchstart', 'focusin'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        if (!e.target || !e.target.closest) return;
        if (!e.target.closest('variant-selects, .product-form__input')) return;
        warm();
      }, { capture: true, passive: true });
    });

    document.addEventListener('change', later, true);

    /* Het variantenblok wordt als geheel vervangen. De waarnemer draait nog
       voor het beeldje getekend wordt, dus verse plaatjes zijn meteen bekend.
       We hangen aan de OUDER, want het blok zelf verdwijnt. */
    if (window.MutationObserver) {
      var host = document.querySelector('.product__info-container');
      if (host) new MutationObserver(later).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start);
  }
})();
